"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_core_1 = require("@patternfly/react-core");
var react_1 = require("react");
function Typeahead(props) {
    var _a, _b, _c;
    var _d = (0, react_1.useState)(false), isOpen = _d[0], setIsOpen = _d[1];
    var _e = (0, react_1.useState)((_a = props.initialSelection) !== null && _a !== void 0 ? _a : ''), selected = _e[0], setSelected = _e[1];
    (0, react_1.useEffect)(function () {
        if (props.initialSelection) {
            setSelected(props.initialSelection);
        }
    }, [props.initialSelection]);
    var onSelect = function (event, selection) {
        setSelected(selection);
        if (props.shouldResetOnSelect) {
            setIsOpen(false);
        }
        var selectedOption = props.options.find(function (option) { return option.value === selection; });
        props.onSelect(selectedOption);
    };
    return ((0, jsx_runtime_1.jsx)(react_core_1.Select, __assign({ variant: react_core_1.SelectVariant.typeahead, typeAheadAriaLabel: props.name, id: props.name, onToggle: function () {
            setIsOpen(!isOpen);
        }, onSelect: onSelect, isOpen: isOpen, selections: selected, shouldResetOnSelect: (_b = props.shouldResetOnSelect) !== null && _b !== void 0 ? _b : false, placeholderText: (_c = props.placeholder) !== null && _c !== void 0 ? _c : 'Select an option...' }, { children: props.options.map(function (option) { return ((0, jsx_runtime_1.jsx)(react_core_1.SelectOption, { value: option.value, selected: true, description: option.description }, option.key)); }) })));
}
exports.default = Typeahead;
